import Link from 'next/link';
import Image from 'next/image';
import { work1, work2, work3, work4 } from '../assets/images';
import { Container, Row, Col } from 'react-bootstrap';
import BrandTicker from './BrandTicker';
import { ArrowRightLong, ArrowWhiteShort } from '../assets/icons';
import { useRouter } from 'next/router';
import parser from 'html-react-parser';
import { captureEvent } from '../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../utils/posthogEvents';

const stepImages = [work1, work2, work3];

const stripDocStyles = (html) =>
  html
    .replace(/\s+style="[^"]*"/g, '')
    .replace(/\s+dir="[^"]*"/g, '')
    .replace(/\s+id="[^"]*"/g, '')
    .replace(/\s+role="[^"]*"/g, '')
    .replace(/\s+aria-level="[^"]*"/g, '');

const Steps = ({
  path = '',
  hide = false,
  steps = theWorks,
  showCTA = true,
  showTicker = true,
  buttonText = 'Start Refill Request',
  subText = '',
  superText = '',
  how_it_works = null,
  onBeforeNavigate = null,
  // Replaces the navigation outright, for a CTA that should act on the
  // current page instead of routing. onBeforeNavigate cannot do this: it runs
  // and then router.push still fires, which resets the scroll position.
  onCtaClick = null,
  // Which page's three-step section this is. This CTA sits on the condition
  // pages, the sexual health landing page and the medication landing page and
  // reported none of them, so every click on it was invisible. Left optional:
  // PostHog records the path beside the event, so an unlabelled caller is
  // still attributable to its page.
  placement = PH_PLACEMENT.HOW_IT_WORKS,
}) => {
  const router = useRouter();

  const goToLink = () => {
    // Above the onCtaClick return: the CTA was clicked either way, whether
    // it navigates or acts on the page it is already on.
    captureEvent(PH_DIRECT.CLICK, {
      cta: PH_CTA.START_TREATMENT,
      placement,
    });
    if (onCtaClick) {
      onCtaClick();
      return;
    }
    if (onBeforeNavigate) onBeforeNavigate();
    router.push(path ? `${path}` : '#');
  };
  const hasBackendContent =
    how_it_works != null &&
    !!(how_it_works.label || how_it_works.heading || how_it_works.subtitle);
  const isBackend = hasBackendContent;
  const displaySteps =
    isBackend && how_it_works.steps?.length ? how_it_works.steps : steps;

  const buildHeading = (heading) => {
    if (!heading) return <span className='gradientText'>Works</span>;
    const words = heading.trim().split(' ');
    const last = words.pop();
    return (
      <>
        {words.join(' ')}
        {words.length ? ' ' : ''}
        <span className='gradientText'>{last}</span>
      </>
    );
  };

  return (
    <div className='stepsWrapper'>
      <div className='stepsContainer'>
        {' '}
        <div className='titleWithCta'>
          <div className='tw-flex tw-flex-col tw-gap-y-4 tw-w-full'>
            <p className='tw-m-0 tw-font-medium lg:tw-text-xl tw-text-[#195D9D] '>
              {isBackend ? how_it_works.label : superText}
            </p>
            <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-2'>
              {' '}
              <h2 className='tw-text-[2rem] tw-font-semibold lg:tw-text-[2.75rem] tw-m-0'>
                {isBackend ? (
                  buildHeading(how_it_works.heading)
                ) : (
                  <>
                    How it <span className='gradientText'>Works</span>
                  </>
                )}
              </h2>
              <p className='tw-m-0 tw-text-[#5F5F5F]'>
                {isBackend ? how_it_works.subtitle : subText}
              </p>
            </div>
          </div>
        </div>
        <Container
          fluid
          className='px-0 tw-flex tw-flex-col tw-gap-y-8 lg:tw-gap-y-16'
        >
          <Row className='g-4'>
            {displaySteps.map((item, index) => (
              <Col lg={4} key={index} className=''>
                <Row className='px-0 '>
                  <Col lg={12} className='px-0'>
                    <div className='tw-w-full tw-flex tw-flex-col tw-items-center  '>
                      <div className='stepImage '>
                        <Image
                          src={
                            isBackend
                              ? stepImages[index] ?? stepImages[0]
                              : item.img
                          }
                          layout='fill'
                          objectFit='contain'
                          alt='step-image'
                          quality={100}
                          objectPosition='center'
                        />
                      </div>
                    </div>
                  </Col>
                  <Col className='tw-mt-8 lg:tw-mt-10'>
                    <div className='stepSection'>
                      <h4 className='stepTitle tw-text-center lg:tw-text-left'>
                        {index + 1}. {item.title}
                      </h4>
                      {isBackend ? (
                        <div className='stepBody [&_li_p]:tw-mb-0'>
                          {typeof item.description === 'string'
                            ? parser(stripDocStyles(item.description))
                            : null}
                        </div>
                      ) : (
                        <p className='stepBody'>{item.body}</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
          <button
            onClick={() => goToLink()}
            className='tw-place-self-center lg:tw-place-self-end steps-cta tw-border-none tw-w-full lg:tw-w-max'
          >
            <div className='tw-bg-black tw-text-white tw-px-4 tw-py-3 lg:tw-px-6  tw-rounded-full tw-flex tw-items-center tw-justify-center tw-gap-x-2 tw-font-medium tw-whitespace-nowrap'>
              {buttonText}
              <ArrowWhiteShort />
            </div>
          </button>
        </Container>
        {/* <button
          onClick={() => goToLink()}
          className=' tw-place-self-center lg:tw-place-self-end steps-cta tw-border-none tw-w-full'
        >
          <div className='tw-bg-black tw-text-white tw-px-4 tw-py-3 lg:tw-px-6  tw-rounded-full tw-flex tw-items-center tw-justify-center tw-gap-x-2 tw-font-medium tw-whitespace-nowrap'>
            {buttonText}
            <ArrowWhiteShort />
          </div>
        </button> */}
        {showTicker && (
          <div
            style={{ margin: '6rem 0 0rem', width: '-webkit-fill-available' }}
          >
            {hide ? null : <BrandTicker />}
          </div>
        )}
      </div>
    </div>
  );
};

export default Steps;
const theWorks = [
  {
    id: 1,
    img: work1,
    title: 'Enter your information',
    body: 'Provide your medical history and details about your health and symptoms.',
  },
  {
    id: 2,
    img: work2,
    title: 'Doctor’s review',
    body: 'Our board-certified medical providers will review your info and create a personalized treatment plan.',
  },
  {
    id: 3,
    img: work3,
    title: 'Get your prescription',
    body: 'Get treatment plan and pick up Rx at your local pharmacy within 45 minutes. For some of our programs we offer home delivery.',
  },
  // {
  //   id: 4,
  //   img: work4,
  //   title: '4. Follow-up support',
  //   body: 'Get unlimited support and telehealth visits, plus prescription refills at standard cost.',
  // },
];
